module.exports = __webpack_public_path__ + "static/works-bcremit-7b98dbb3e77ba5da988608adf3b7b582.jpg";